import React from 'react'
import { Container, Row, Col, Input, Button } from 'reactstrap'
import { useHistory } from "react-router-dom";

const Main = (props) => {
  const history = useHistory();
  return (
    <div className="main">
      <Container className="section">
        <Col lg={6}>
          <span className="span-madeby">Made by &nbsp; <img className="smile-icon" src={require('../_assets/image/icon2.png')} /></span>
          <p className="ppp">Develop your enterprise-grade applications 4X faster and cheaper. Irithm is an AI-assisted visual drag and drop app builder for NO CODE and LOW CODE users. Create your mobile, desktop and web applications easier and faster.</p>
        </Col>
      </Container>

      <Container className="section">
        <Col lg={6}>
          <p className="feature-title">
            Join us on the release of our Alpha version on June 10, 2020!
          </p>
          <Input
            type="name"
            name="name"
            className="input"
            placeholder="your goodname"
          />
          <Input
            type="email"
            name="email"
            className="input2"
            placeholder="email address"
          />
          <Button className="btn-join" color="primary">JOIN THE WAITLIST</Button>
        </Col>
      </Container>

      <Container className="section">
        <Row>
          <Col lg={4} sm={12} md={4}>
            <img src={require('../_assets/image/home-group/Group5.png')} />
            <p className="feature-title">NO CODE REQUIRED</p>
            <p className="feature-desc">Use visual programming *scratch-like* block to build pixel perfect mobile, web and desktop applications.</p>
          </Col>
          <Col lg={4} sm={12} md={4}>
            <img src={require('../_assets/image/home-group/Group6.png')} />
            <p className="feature-title">MEET JULIA</p>
            <p className="feature-desc">AI assisted chatbot provides you instant help and recommendations during your developlement journey.</p>
          </Col>
          <Col lg={4} sm={12} md={4}>
            <img src={require('../_assets/image/home-group/Group2.png')} />
            <p className="feature-title">LOW CODE EXITS</p>
            <p className="feature-desc">Cut 50% of keystrockes needed to build an enterprise-level app using irithm online code editor</p>
          </Col>
        </Row>
      </Container>


      <Container className="section">
        <Row>
          <Col lg={4} sm={12} md={4}>
            <img src={require('../_assets/image/home-group/Group4.png')} />
            <p className="feature-title">CLOUD BASE PLATFORM</p>
            <p className="feature-desc">Cloud native experience supported by Google Firebase. Recieve real time tracking of your development.</p>
          </Col>
          <Col lg={4} sm={12} md={4}>
            <img src={require('../_assets/image/home-group/Group1.png')} />
            <p className="feature-title">PIXEL PERFECT DESIGN</p>
            <p className="feature-desc">Build your actual user interface using popular UI/UX tool kits like Adobe XD, Google Flutter and Supernova.io.</p>
          </Col>
          <Col lg={4} sm={12} md={4}>
            <img src={require('../_assets/image/home-group/Group3.png')} />
            <p className="feature-title">iRExt</p>
            <p className="feature-desc">Tell iRithm what you want not how to do it through iRExt transpired declarative language and natural language.</p>
          </Col>
        </Row>
      </Container>

      <Container className="section">
        <Col lg={10}>
          <p className="feature-title">
            See iRithm in action
          </p>
          <div className="embed-responsive embed-responsive-16by9">
            <iframe
              className="embed-responsive-item"
              src="https://www.youtube.com/embed/ML6GwnhyhWA?v=0"
              allowFullScreen="allowfullscreen"
            ></iframe>
          </div>
          <Button className="btn-join" color="primary">JOIN THE WAITLIST</Button>
        </Col>
      </Container>


      <Container className="section">
        <Row>
          <Col lg={7}>
          <div className="embed-responsive embed-responsive-1by1">
            <iframe
              className="embed-responsive-item video"
              src={require('../_assets/video/nocode.mp4')}
              allowFullScreen="allowfullscreen"
            ></iframe>
          </div>
          </Col>
          <Col className="container-center" lg={5} sm={12}>
            <img src={require('../_assets/image/home-group/Group5.png')} />
            <p className="feature-title">NO CODE REQUIRED</p>
            <p className="feature-desc">Use visual programming *scratch-like* block to build pixel perfect mobile, web and desktop applications.</p>
          </Col>
        </Row>
      </Container>


      <Container className="section">
        <Row>
          <Col lg={7}>
          <div className="embed-responsive embed-responsive-1by1">
            <iframe
              className="embed-responsive-item video"
              src={require('../_assets/video/meetjulia.mp4')}
              allowFullScreen="allowfullscreen"
            ></iframe>
          </div>
          </Col>
          <Col className="container-center" lg={5} sm={12}>
            <img src={require('../_assets/image/home-group/Group6.png')} />
            <p className="feature-title">MEET JULIA</p>
            <p className="feature-desc">AI assisted chatbot provides you instant help and recommendations during your developlement journey.</p>
          </Col>
        </Row>
      </Container>

{/* 
      <Container className="section">
        <Row>
          <Col lg={7}>
            <img src={require('../_assets/image/carousel/phone_bezel.png')} className='img-phone-bezel' />
          </Col>
          <Col className="container-center" lg={5} sm={12}>
            <img src={require('../_assets/image/home-group/Group2.png')} />
            <p className="feature-title">LOW CODE EXITS</p>
            <p className="feature-desc">Cut 50% of keystrockes needed to build an enterprise-level app using irithm online code editor</p>
          </Col>
        </Row>
      </Container> */}

      {/* <Container className="section">
        <Row>
          <Col lg={7}>
            <img src={require('../_assets/image/carousel/phone_bezel.png')} className='img-phone-bezel' />
          </Col>
          <Col className="container-center" lg={5} sm={12}>
            <img src={require('../_assets/image/home-group/Group4.png')} />
            <p className="feature-title">CLOUD BASE PLATFORM</p>
            <p className="feature-desc">Cloud native experience supported by Google Firebase. Recieve real time tracking of your development.</p>
          </Col>
        </Row>
      </Container> */}

      <Container className="section">
        <Row>
          <Col lg={7}>
          <div className="embed-responsive embed-responsive-1by1">
            <iframe
              className="embed-responsive-item video"
              src={require('../_assets/video/pixelperfect.mp4')}
              allowFullScreen="allowfullscreen"
            ></iframe>
          </div>
          </Col>
          <Col className="container-center" lg={5} sm={12}>
            <img src={require('../_assets/image/home-group/Group1.png')} />
            <p className="feature-title">PIXEL PERFECT DESIGN</p>
            <p className="feature-desc">Build your actual user interface using popular UI/UX tool kits like Adobe XD, Google Flutter and Supernova.io.</p>
          </Col>
        </Row>
      </Container>
{/* 
      <Container className="section">
        <Row>
          <Col lg={7}>
            <img src={require('../_assets/image/carousel/phone_bezel.png')} className='img-phone-bezel' />
          </Col>
          <Col className="container-center" lg={5} sm={12}>
            <img src={require('../_assets/image/home-group/Group3.png')} />
            <p className="feature-title">iRExt</p>
            <p className="feature-desc">Tell iRithm what you want not how to do it through iRExt transpired declarative language and natural language.</p>
          </Col>
        </Row>
      </Container> */}

      <Container className="section">
        <Col lg={6}>
          <span className="span-madeby">Always Innovating</span>
          <p className="ppp">Invest in a platform that continuously learns. Our platform-enhanced
machine-learning capabilities push application development to another level.</p>
<Button 
  onClick={() => history.push('/investor')}
 className="btn-join" color="primary">Invest with us</Button>
        </Col>
      </Container>

    </div>
  )
}

export default Main

